import { QueryKey } from '@tanstack/react-query';

export const composeQueryKey = (key: QueryKey, ...args: any[]) => [
  key,
  { ...args },
];
